import { axios } from "../helpers";
import buildSettings from "../buildSettings.json";

export const getLocations = async (page: number = 1) => {
  const url = `${buildSettings.REACT_APP_API_URL}location?per_page=100&page=${page}`;
  return await axios.get(url);
};

export const getProviders = async (page: number = 1) => {
  const url = `${buildSettings.REACT_APP_API_URL}provider?per_page=100&page=${page}`;
  return await axios.get(url);
};

export const getLocationFromAddress = async (address: string) => {
  const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=${buildSettings.REACT_APP_GOOGLE_KEY}`;
  return await axios.get(url);
};

export const getAddressFromLocation = async (lat: number, lng: number) => {
  const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${buildSettings.REACT_APP_GOOGLE_KEY}`;
  return await axios.get(url);
};
